import { defineStore } from 'pinia'
import apiService from '../services/api'
import type { AxiosResponse } from 'axios'

// Definim interfața pentru StudyDTO
interface StudyDTO {
  id: number
  studyID: string | null
  studyDescription: string
  storedFiles: Array<{
    id: number
    fileName: string
    studyDateTime: string | null
    studyDescription: string | null
    isEligibleForAltris: boolean | null
    fileLocation: string
    bucketName: string
    fileResource: string | null
    altrisExamination: {
      pdfLocation: string | null
      status: string | null
      errorMessage: string | null
    } | null
    patient: {
      patientAge: string | null
      patientBirthday: string | null
      patientID: string | null
      patientName: string | null
      patientSex: string | null
    } | null
  }>
}

// Definim store-ul Pinia pentru fișiere (studies)
export const useStudyStore = defineStore('StudyStore', {
  state: () => ({
    studies: [] as StudyDTO[] // Array pentru a stoca lista de studii
  }),

  actions: {
    // Funcția pentru a obține studiile bazate pe tenantId, patientId și deviceId
    async fetchStudies(patientId: string | null, deviceId: string) {
      try {
        // Facem o cerere GET la endpoint-ul specificat
        const response: AxiosResponse<StudyDTO[]> = await apiService.get(
          `/study/studies/patient`,
          {
            encodedPatientId: patientId,
            deviceId: deviceId
          }
        )
        this.studies = response.data // Stocăm studiile primite în state
      } catch (error) {
        console.error('Error fetching studies:', error)
      }
    }
  },

  getters: {
    // Getter pentru a obține toate studiile
    allStudies(state) {
      return state.studies
    }
  }
})
